import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class OcorrenciaValidation extends DefaultValidation {
    constructor(msgs) {
		super(msgs);
	  }
	  validate(model, refs) {
		let validated = true;

		Object.entries(model).forEach(([key, value]) => {
			if(value!=null && typeof value == "string") model[key] = value.trim();
		  });
	  
		  if (Util.isNull(model.descricao) || Util.isNull(model.icone) || Util.isNull(model.imagem)) {
			refs.imageInput.focusedOut = true;
			refs.iconeInput.focusedOut = true;
			refs.descricaoInput.focusedOut = true;
			validated = false;
		  }
		  if (Util.isNull(model.cor)) {
			refs.cpInput.focusedOut = true;
			validated = false;
		  }

		return validated;
	}
}
